"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectProps = void 0;

var _react = require("react");

const injectProps = ({
  activeIndex,
  handleChange,
  onTabChange
} = {}) => (child, index) => /*#__PURE__*/(0, _react.cloneElement)(child, {
  index,
  isActive: activeIndex === index,
  onTabClick: () => {
    handleChange(index);
    onTabChange(index);
  }
});

exports.injectProps = injectProps;